export const CONFIG_DATA_PENDING = 'CONFIG_DATA_PENDING';
export const CONFIG_DATA_FULFILLED = 'CONFIG_DATA_FULFILLED';
export const CONFIG_DATA_REJECTED = 'CONFIG_DATA_REJECTED';
